import { createDevice } from 'common/utils/helpers';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

export const getDevice = (id) => {
  const url = apiConfig.cmServiceDevices(id);
  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return createDevice(result.devices);
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
};
